import { useEffect } from "react"

/**
 * Sways the mesh gradient's angle from a rAF clock: with t in seconds,
 * spin = t * 0.5 and angle = sin(spin * 0.6) * 24 * 0.34 — a sway, not a
 * turn. sin(0) = 0, so the gradient starts exactly where the static fallback
 * paints it and nothing snaps when motion begins. The value is deliberately
 * never rounded; quantising it per frame is what makes motion visibly step.
 *
 * One loop drives every mesh on the page via a root-level CSS variable, so
 * the panels sway in phase. Reduced motion never starts the loop and the
 * var's static 0deg fallback applies.
 */
export function useMeshSway() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    const root = document.documentElement
    const start = performance.now()
    let raf = 0

    const frame = (now: number) => {
      const t = (now - start) / 1000
      const spin = t * 0.5
      const angle = Math.sin(spin * 0.6) * 24 * 0.34
      root.style.setProperty("--lp-mesh-angle", `${angle}deg`)
      raf = requestAnimationFrame(frame)
    }

    raf = requestAnimationFrame(frame)
    return () => {
      cancelAnimationFrame(raf)
      root.style.removeProperty("--lp-mesh-angle")
    }
  }, [])
}
